// removed by extract-text-webpack-plugin
module.exports = {"forgotPasswordForm":"forgotPasswordForm___1qzNO","forgotPasswordFormBtn":"forgotPasswordFormBtn___2JzAP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotPassword/styles.less
// module id = k3b7
// module chunks = 18